export enum ScopeStatus {
  IN_SCOPE = 'IN_SCOPE',
  CARVE_IN = 'CARVE_IN',
  CARVE_OUT = 'CARVE_OUT',
}
